import { HttpClient } from "@angular/common/http";
import { Injectable, NgZone } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestore } from "@angular/fire/firestore";
import { ADMIN_API_URL } from "../../config/config";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  userData: any; // Save logged in user data

  constructor(
    public afs: AngularFirestore, // Inject Firestore service
    public http: HttpClient,
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    public router: Router,
    public ngZone: NgZone // NgZone service to remove outside scope warning
  ) {
    /* Saving user data in localstorage when
    logged in and setting up null when logged out */
    this.afAuth.authState.subscribe(async (user) => {
      if (user) {
        this.userData = user.toJSON();
        localStorage.setItem("user", JSON.stringify(this.userData));
        user
          .getIdTokenResult()
          .then((res) => {
            if (res.claims.almighty) {
              localStorage.setItem("almighty", "true");
              localStorage.setItem("isAdmin", "true");
              localStorage.setItem("isModerator", "true");
            } else if (res.claims.superadmin) {
              localStorage.setItem("isAdmin", "true");
              localStorage.setItem("isModerator", "true");
            } else if (res.claims.admin) {
              localStorage.setItem("isAdmin", "true");
            } else if (res.claims.moderator) {
              localStorage.setItem("isModerator", "true");
            }
            user.getIdToken().then((token) => {
              localStorage.setItem("idToken", token);
            });
          })
          .catch((error) => {
            throw new Error(error);
          });
      } else {
        localStorage.clear();
        this.router.navigate(["/login"]);
        // JSON.parse(localStorage.getItem('user'));
      }
    });
  }

  // Sign in with email/password
  async signIn(email: string, password: string) {
    try {
      const response = await this.afAuth.auth.signInWithEmailAndPassword(
        email,
        password
      );
      const user = response.user.toJSON();
      const res = await response.user.getIdTokenResult();
      // console.log('CLAIMSSSS: ', res.claims);
      this.ngZone.run(() => {
        if (res.claims.almighty) {
          localStorage.setItem("almighty", "true");
          localStorage.setItem("isAdmin", "true");
          localStorage.setItem("isModerator", "true");
        } else if (res.claims.superadmin) {
          localStorage.setItem("isAdmin", "true");
          localStorage.setItem("isModerator", "true");
        } else if (res.claims.admin) {
          localStorage.setItem("isAdmin", "true");
        } else if (res.claims.moderator) {
          localStorage.setItem("isModerator", "true");
        } else {
          this.afAuth.auth.signOut();
          throw new Error("Not Admin");
        }
        localStorage.setItem("idToken", res.token);
        localStorage.setItem("user", JSON.stringify(user));
        this.router.navigate(["/home"]);
      });
      // this.SetUserData(result.user);
    } catch (error) {
      console.log(error);
      throw error.message;
    }
  }

  createUser(email: string, password: string, name: string) {
    const url = ADMIN_API_URL + "/createUser";

    const body = {
      displayName: name,
      email: email,
      password: password,
    };

    return this.http.post(url, body).toPromise();

    // return await this.afAuth.auth.createUserWithEmailAndPassword(
    //   email,
    //   password
    // );
  }

  // Sign up with email/password
  async signUp(email: string, password: string) {
    try {
      const result = await this.afAuth.auth.createUserWithEmailAndPassword(
        email,
        password
      );
      /* Call the SendVerificaitonMail() function when new user sign
      up and returns promise */
      // this.SetUserData(result.user);
      this.SendVerificationMail();
    } catch (error) {
      window.alert(error.message);
    }
  }

  // Send email verfificaiton when new user sign up
  async SendVerificationMail() {
    await this.afAuth.auth.currentUser.sendEmailVerification();
    this.router.navigate(["verify-email-address"]);
  }

  // Reset Forggot password
  async forgotPassword(passwordResetEmail) {
    try {
      await this.afAuth.auth.sendPasswordResetEmail(passwordResetEmail);
      window.alert(
        "Se ha enviado un correo con los pasos a seguir para restablecer su cuenta."
      );
    } catch (error) {
      window.alert(error);
    }
  }

  // Returns true when user is looged in and email is verified
  get isLoggedIn(): boolean {
    this.afAuth.authState.subscribe(async (user) => {
      if (user) {
        this.userData = user.toJSON();
        localStorage.setItem("user", JSON.stringify(this.userData));
        user
          .getIdTokenResult()
          .then((res) => {
            if (res.claims.almighty) {
              localStorage.setItem("almighty", "true");
              localStorage.setItem("isAdmin", "true");
              localStorage.setItem("isModerator", "true");
            } else if (res.claims.superadmin) {
              localStorage.setItem("isAdmin", "true");
              localStorage.setItem("isModerator", "true");
            } else if (res.claims.admin) {
              localStorage.setItem("isAdmin", "true");
            } else if (res.claims.moderator) {
              localStorage.setItem("isModerator", "true");
            }
            user.getIdToken().then((token) => {
              localStorage.setItem("idToken", token);
            });
          })
          .catch((error) => {
            throw new Error(error);
          });
      } else {
        localStorage.clear();
        // this.router.navigate(['/login']);
        // JSON.parse(localStorage.getItem('user'));
      }
    });
    const user = JSON.parse(localStorage.getItem("user"));
    // return (user !== null && user.emailVerified !== false) ? true : false;
    return user !== null ? true : false;
  }

  // Sign in with Google
  // GoogleAuth() {
  //   return this.AuthLogin(new auth.GoogleAuthProvider());
  // }

  // Auth logic to run auth providers
  // AuthLogin(provider) {
  //   return this.afAuth.auth.signInWithPopup(provider)
  //     .then((result) => {
  //       this.ngZone.run(() => {
  //         this.router.navigate(['dashboard']);
  //       })
  //       this.SetUserData(result.user);
  //     }).catch((error) => {
  //       window.alert(error)
  //     })
  // }

  /* Setting up user data when sign in with username/password,
  sign up with username/password and sign in with social auth
  provider in Firestore database using AngularFirestore + AngularFirestoreDocument service */
  // SetUserData(user) {
  //   const userRef: AngularFirestoreDocument<any> = this.afs.doc(`admins/${user.uid}`);
  //   const userData: User = {
  //     uid: user.uid,
  //     email: user.email,
  //     displayName: user.displayName,
  //     photoURL: user.photoURL,
  //     emailVerified: user.emailVerified
  //   };
  //   return userRef.set(userData, {
  //     merge: true
  //   });
  // }
  async getToken() {
    this.afAuth.authState.subscribe(async (user) => {
      if (user) {
        user.getIdToken().then((token) => {
          localStorage.setItem("idToken", token);
        });
      } else {
        localStorage.setItem("user", null);
        this.router.navigate(["/login"]);
      }
    });
    // await this.afAuth.auth.currentUser.getIdToken().then(token => {
    //   console.log(token);
    //   localStorage.setItem('idToken', token);
    //   return token;
    // });
  }

  // Sign out
  async signOut() {
    await this.afAuth.auth.signOut();
    localStorage.clear();
    this.router.navigate(["/login"]);
  }
}
